<template>
    <v-autocomplete id="country-field" :items="items" :label="`${$t('login.fields.labels.country')}${required ? ' *': ''}`" :item-text="$i18n.locale" :item-value="$i18n.locale" small-chips :clearable="!required"
                    @input="$emit('input', JSON.stringify($event))" :rules="rules" autocomplete="disabled"></v-autocomplete>
</template>

<script>
    import { mapState } from 'vuex';


    export default {
        name: 'CountryField',
        props: {
            required: Boolean,
            items: Array,
        },
        computed: {
            ...mapState( ['countries'] ),
            rules ()
            {
                return [
                    v => !this.required || !!v || this.$t('login.fields.rules.required'),
                ];
            },
        },
    };
</script>

<style scoped>

</style>